export interface CredentialsDto {
  email: string;
  password: string;
  /**
   * Second factor for a user with two-factor authentication: the 6-digit
   * code from the authenticator app, or one of the backup codes. Auth
   * answers `totp_required` when the user needs one and none was sent
   * (tendril-connect#2251).
   */
  totp_code?: string;
  backup_code?: string;
}

/** `code` values the auth service puts in two-factor error bodies. */
export type AuthErrorCode =
  | 'totp_required'
  | 'totp_invalid'
  | 'totp_locked'
  | 'totp_not_pending'
  | 'totp_not_enabled'
  | 'totp_already_enabled'
  | 'password_invalid'
  | 'password_locked';

/** The `{ status, data }` envelope of the auth two-factor routes. */
export interface AuthEnvelope<T> {
  status: string;
  data: T;
}

export interface TotpStatus {
  enabled: boolean;
  backup_codes_left: number;
}

export interface TotpEnrollment {
  /** The key as text, for apps that cannot scan the QR. */
  secret: string;
  otpauth_url: string;
  qr_png_base64: string;
  /** Seconds the setup stays valid. */
  expires_in: number;
}

export interface TotpConfirmation {
  enabled: boolean;
  backup_codes: string[];
}

export interface BackupCode {
  code: string;
  used: boolean;
}

export class ResetPasswordDto {
  email!: string;
  current_pass!: string;
  new_pass_first!: string;
  new_pass_second!: string;
}

export class AdminResetPasswordDto {
  adminEmail!: string;
  userEmail!: string;
  adminPassword!: string;
  newPassword!: string;
}

export interface AuthenticationResponse {
  access_token: string;
  /**
   * Edge session token. Returned by auth `/user/login`, which obtains it
   * from edge over the sealed channel (tendril-connect#2224). Absent on
   * refresh.
   */
  edge_token?: string;
  status: string;
}

export interface AuthApiResponse {
  access_token?: string;
  edge_token?: string;
}

export interface UserData {
  createdAt: Date;
  email: string;
  external_id: string;
  id: string;
  updatedAt: Date;
}

export interface UserDataResponse {
  data: UserData;
  status: string;
}

export interface LogoutResponse {
  success: string;
}

export class UpdateEdgePasswordDto {
  token!: string;
  password!: string;
  currentPassword!: string;
}